// extracted by mini-css-extract-plugin
export default {"tableDrag":"roadmap-table-drag-sash-module__tableDrag--Pk5Ci","tableHeaderDrag":"roadmap-table-drag-sash-module__tableHeaderDrag--c_jAf"};